const images = {
  logo: '/assets/components/CLogin/logo-yellow.png',
  unselect: '/assets/components/CLogin/ic-unselect.png',
  select: '/assets/components/CLogin/ic-select.png',
  set: '/assets/components/CLogin/ic-set.png',
  corlogo: '/assets/components/CLogin/logo-03.png',
};

export default images;
